<template>
  <el-card class="list">
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{name: 'news/drafts'}">
          Drafts
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="search">
        <fuzzy-search collection-name="drafts" :properties="['type', 'header', 'recipient', 'language']"></fuzzy-search>
        <el-button size="mini" @click="fetchAll">
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </el-button>
      </div>
    </div>
    <paginator collection-name="drafts"></paginator>
    <el-table :data="drafts" style="width: 100%" border>
      <sortable-column prop="language" label="LANGUAGE" width="140" collection-name="drafts"></sortable-column>
      <sortable-column prop="created_date" label="CREATED" width="180" :formatter="dateFormatter" collection-name="drafts"></sortable-column>
      <sortable-column prop="type" label="TYPE" width="110" collection-name="drafts"></sortable-column>
      <sortable-column prop="header" label="HEADER" collection-name="drafts"></sortable-column>
      <sortable-column prop="recipient" label="TO" width="110" collection-name="drafts"></sortable-column>
      <el-table-column width="60" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click.prevent="details(scope.row.id)">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
          </el-button>
          <el-button type="text" @click.prevent="edit(scope.row.id)">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    drafts () {
      return this.ids.map(id => this.entities[id])
    },
    ...mapState('drafts', {
      ids: state => state.paginator.ids,
      entities: state => state.entities,
      loaded: state => state.loaded
    })
  },

  methods: {
    details (id) {
      this.select(id)
      this.$router.push({ name: 'news/drafts/show', params: { id: id } })
    },
    edit (id) {
      this.select(id)
      this.$router.push({ name: 'news/drafts/edit', params: { id: id } })
    },
    dateFormatter (row, col) {
      return moment(row.created_date).format('lll')
    },
    ...mapActions('drafts', {
      fetchAll: 'fetchAll',
      select: 'select'
    })
  },

  created () {
    if (!this.loaded) {
      this.fetchAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/Drafts.vue